const LOG_PREFIX = "[VaultMigration]";

const asString = (value) => {
  if (value instanceof Error) {
    return `${value.name}: ${value.message}`;
  }
  if (typeof value === "string") {
    return value;
  }
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

export const logger = {
  info(message, meta) {
    console.info(`${LOG_PREFIX} ${asString(message)}`, meta || "");
  },
  warn(message, meta) {
    console.warn(`${LOG_PREFIX} ${asString(message)}`, meta || "");
  },
  error(message, meta) {
    console.error(`${LOG_PREFIX} ${asString(message)}`, meta || "");
  },
};
